import { useMemo } from 'react';
import { EnhancedSection, FormSchemaConfig } from '../../types/form/schema.types';
import { FormState } from '../../types';

export const useDocumentSavingSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const isEditAllowed = Array.isArray(formState.data?.userAssignedSections)
      ? (formState.data?.userAssignedSections as string[]).includes(
          'document_saving'
        )
      : false;
    const documentSavingSection: EnhancedSection = {
      title: {
        text: 'Document Saving',
        type: 'h3',
      },
      layout: 'single',
      fields: [
        {
          type: 'radio',
          name: 'documents_saved',
          label:
            'Please confirm all supporting documents have been saved in the DMS',
          options: [
            {
              value: 'verified',
              label: 'Acknowledge',
              disabled: false,
            },
          ],
          disabled:
            formState.completedSections?.includes('document_saving') ||
            !isEditAllowed,
          required: true,
          validate: (value) =>
            !value ? 'Please acknowledge if the documents have been saved' : undefined,
        },
        {
          type: 'radio',
          name: 'form_saved',
          label: 'Please confirm a copy of the form has been saved in the DMS',
          options: [
            {
              value: 'verified',
              label: 'Acknowledge',
              disabled: false,
            },
          ],
          disabled:
            formState.completedSections?.includes('document_saving') ||
            !isEditAllowed,
          required: true,
          validate: (value) =>
            !value ? 'Please acknowledge if the form has been saved' : undefined,
        },
      ],
      extras: { grouped: true, evenSpacing: true },
    };

    return {
      sections: [documentSavingSection],
    };
  }, [formState]);
};
